import { useQuery } from "@tanstack/react-query";

import { getBulkExports } from "@nens/ldo/api-v1";
import { BulkAction } from "@nens/ldo/hooks";

type AddToExportBulkActionParams = {
  disabled?: boolean;
  title: string;
  onClick: () => void;
};

export function useAddToExportBulkAction({
  title,
  disabled = false,
  onClick,
}: AddToExportBulkActionParams) {
  const bulkExportsResponse = useQuery(getBulkExports("all", { status: "incomplete" }));
  const bulkExports = bulkExportsResponse.data?.items ?? [];

  const addToExportBulkAction: BulkAction = {
    title,
    hidden: bulkExports.length === 0,
    disabled: disabled || bulkExports.length === 0,
    running: false,
    run: onClick,
  };

  return {
    addToExportBulkAction,
    bulkExports,
  };
}
